import styled from '@emotion/styled';
import { theme, media, pxToRem } from '@vfit/shared/themes';
import { css } from '@emotion/react';

export const CardInfoProductContainer = styled.div`
  display: block;

  .swiper-wrapper {
    height: inherit;
  }

  ${media.tablet`
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-bottom: 45px;
  `}

  ${media.bigDesktop`
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-bottom: 120px;
  `}
`;

export const CardInfoProductContent = styled.div`
  width: 100%;
`;

export const DescriptionContainer = styled.div`
  margin-top: 80px;
  padding: 0 30px;
  div {
    margin: 0;
  }
  div p {
    margin: 0;
  }
`;

export const DisclaimerContainer = styled.div`
  font-family: ${theme.typography.fontFamily.primary};
  font-weight: ${theme.typography.fontWeight.bold};
  color: ${theme.colors.text.secondary};

  img {
    width: 18px;
  }
`;

const commonRichTextStyles = css`
  b {
    font-family: ${theme.typography.fontFamily.primary};
    font-weight: ${theme.typography.fontWeight.extrabold};
  }

  img {
    cursor: text;
    vertical-align: baseline;
  }

  a {
    color: ${theme.colors.text.primary};
    font-weight: ${theme.typography.fontWeight.bold};

    &:hover {
      color: ${theme.colors.text.link};
    }
  }

  button {
    font-family: ${theme.typography.fontFamily.primary};
    font-weight: ${theme.typography.fontWeight.extrabold};
    font-size: ${theme.typography.fontSize.display5};

    color: ${theme.colors.text.brand};
    background: none;
    border: none;
    padding: 0;
    outline: inherit;

    span {
      font-family: ${theme.typography.fontFamily.secondary};
      font-weight: ${theme.typography.fontWeight.light};
      color: ${theme.colors.text.inverse};
      background-color: ${theme.colors.brand.primary};
      padding-left: ${theme.spacing.sm};
      padding-right: ${theme.spacing.sm};
      border-radius: 50%;
      cursor: pointer;
    }

    &:hover {
      span {
        background-color: ${theme.colors.text.linkHover};
      }
    }

    &:active {
      span {
        background-color: ${theme.colors.interactive.active};
      }
    }
  }
`;

export const TopText = styled.div`
  ${commonRichTextStyles}
  margin: 0;
  text-align: center;
  margin-top: ${theme.spacing.md};
  margin-bottom: ${theme.spacing.xl};
  font-family: ${theme.typography.fontFamily.primary};
  font-weight: ${theme.typography.fontWeight.light};
  font-size: ${pxToRem(30)};
  line-height: ${pxToRem(38)};

  ${media.tablet`
    font-size: ${theme.typography.fontSize.h2};
    line-height: ${theme.typography.lineHeight.h2};
  `}
`;

export const DescriptionText = styled.div`
  ${commonRichTextStyles}
  margin: 0;
  text-align: center;
  margin-top: ${theme.spacing.md};
  margin-bottom: ${theme.spacing.xl};
  font-family: ${theme.typography.fontFamily.primary};
  font-weight: ${theme.typography.fontWeight.regular};
  font-size: ${pxToRem(22)};
  line-height: ${pxToRem(32)};
`;

export const DisclaimerText = styled.div`
  ${commonRichTextStyles}
  margin: 48px 23px 31px 23px;
  text-align: left;
  font-family: ${theme.typography.fontFamily.primary};
  font-weight: ${theme.typography.fontWeight.light};
  font-size: ${theme.typography.fontSize.body2};
  line-height: ${theme.typography.lineHeight.body2};
`;

